<template>
    <ui-modal>
        <template #header>
            <h3 v-text="'Zgody telekomunikacyjne COMP S.A.'" class="text-center" />
        </template>

        <consents-form
            :consents="formConsents"
            @change="formConsents = $event"
        />
        <p
            v-text="`Zgody możesz wycofać w każdej chwili w sekcji Ustawienia.
                Wystarczy, że klikniesz pole przy danej zgodzie i zapiszesz zmiany.`"
            class="pt-3 mt-3 mb-0 border-top"
        />

        <template #footer>
            <the-btn
                text="Zamknij"
                class="btn-outline-custom"
                @click="$emit('close-modal')"
            />
            <the-btn
                class="btn-secondary"
                text="Zapisz"
                :disabled="isSaving"
                :loading-status="isSaving ? 'loading' : 'idle'"
                @click="save"
            />
        </template>
    </ui-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    data: () => ({
        formConsents: null,
        isSaving: false
    }),

    computed: {
        ...mapGetters('drsConsents', ['consents'])
    },

    created() {
        this.resetFormConsents()
    },

    methods: {
        ...mapActions('drsConsents', ['saveConsents']),

        resetFormConsents() {
            this.formConsents = this.consents
        },

        async save() {
            if (this.isSaving) {
                return
            }
            this.isSaving = true
            try {
                await this.saveConsents(this.formConsents)
                this.$emit('close-modal')
            } catch {
                this.resetFormConsents()
            } finally {
                this.isSaving = false
            }
        }
    }
}
</script>
